import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TailorBanner from '../components/TailorBanner';
import PageLinks from '../components/PageLinks';
import Brand from '../components/Brand';
import Footer from '../components/Footer';

class Landing extends Component {

  componentDidMount() {
    window.analytics.page("View Homepage");
  }
  
  render() {
    return(
      <div class="public landing">
        <header className="App-header">
          <Brand />
          <PageLinks />
          <ul className="account">
            <Link className="btn" to="/apps">Sign In</Link>
          </ul>
        </header>
        <div class="hero">
          {/*<div class="content">
            <h1>
              The easiest way create your MVP in just minutes
            </h1>
            <h4>
              Discover easy-to-use apps to help launch your ideas.
            </h4>
            <Link className="btn" to="/signup">Get Started For Free</Link>
    </div>*/}
          {/*<div class="graphic"></div>*/}
          <div class="content">
            <h1>
              Work, Wherever
            </h1>
            <h4>
              Find tools to help you work remotely.
            </h4>
            <Link className="btn" to="/signup">Sign Up</Link>
          </div>
        </div>
        <div class="section section-1">
          <div class="content">
            <h2>
              Discover Apps
            </h2>
            <h4>
              Browse and save apps made for people who work remote.
            </h4>
            <Link className="btn" to="/browse">Browse Apps</Link>
          </div>
          <div class="graphic"></div>          
    </div>
        <div class="section section-2">
          <div class="content">
            <h2>
              Stay Organized
            </h2>
            <h4>
              Create stacks for work, projects and more to avoid app overload.
            </h4>
            <Link className="btn" to="/signup">Get Started</Link>
          </div>
          <div class="graphic"></div>          
    </div>
        {/*
        <div className="heading">
            <h1>
              Get your ideas up and running
            </h1>
          </div>
        <div class="section section-0">
          
          
          <div class="content">
            <h3 className="step">1</h3>
            <h3>
              Discover
            </h3>
            <h4>
              Choose from apps like Shopify, Mailchimp, Buildbox, ShareTribe, and more to help you create a simple version of your ideas.
            </h4>
          </div>
          <div class="content">
            <h3 className="step">2</h3>
            <h3>
              Create
            </h3>
            <h4>
              Build your own platform. Start an agency, launch a clothing line, or release a podcast, and manage it from your projects dashboard.
            </h4>
          </div>
          <div class="content">
            <h3 className="step">3</h3>
            <h3>
              Launch
            </h3>
            <h4>
              Tap into Facebook, Kickstarter, Reddit, and other communities to get in front of your audience and test your idea.
            </h4>
          </div>
        </div>
        <div class="section section-1">
          <div class="content">
            <h2>
              Build more than just a website
            </h2>
            <h4>
              Start a community, launch a subscription service, or even create your own AirBnB type business. Execute on your idea quickly and easily.
            </h4>
            <Link className="btn" to="/signup">Start Building For Free</Link>
          </div>
          <div class="graphic">
          </div>
        </div>*/}
        {/*<div class="section section-2">
          <div class="content">
            <h2>
              Your Startup Toolkit
            </h2>
            <h4>
              Create custom dashboards to help manage your toolkit of apps and services.
            </h4>
            <Link className="btn" to="/signup">Start Building</Link>
          </div>
          <div class="graphic"></div>          
    </div>*/}
        {/*<div class="section section-3">
          <div class="content">
            <h2>
              Get Expert Help
            </h2>
            <h4>
              Need help launching your idea? We'll connect you with the right talent to execute for you.
            </h4>
            <Link className="btn" to="/signup" >Start Building</Link>
          </div>
          <div class="graphic"></div>
    </div>*/}
        {/*<div class="section section-3">
          <div class="content">
            <h2>
              Collaborate better
            </h2>
            <h4>
              Invite your team members and keep everyone on the same page.
            </h4>
            <Link className="btn alt" to="/" >Coming Soon</Link>
          </div>
          <div class="graphic"></div>
  </div>*/}
        <br/>
        <Footer />
      </div>
    );
  }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/pages/Landing.js